import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon, XIcon, BadgeCheckIcon } from 'lucide-react';
import { recentPurchases } from '../data/recentPurchases';
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5500;
const GAP = 9000;

/** Corner toast that cycles through recent buyers as social proof. */
export function PurchaseNotifications() {
  const [index, setIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    const showTimer = window.setTimeout(() => setIsVisible(true), index === 0 ? FIRST_DELAY : GAP);
    return () => window.clearTimeout(showTimer);
  }, [index, isDismissed]);
  useEffect(() => {
    if (!isVisible) return;
    const hideTimer = window.setTimeout(() => {
      setIsVisible(false);
      setIndex(current => (current + 1) % recentPurchases.length);
    }, VISIBLE_FOR);
    return () => window.clearTimeout(hideTimer);
  }, [isVisible]);
  const purchase = recentPurchases[index];
  const timeLabel = purchase.minutesAgo <= 1 ? 'przed chwilą' : `${purchase.minutesAgo} min temu`;
  return <div className="pointer-events-none fixed bottom-[84px] left-3 z-50 sm:bottom-5 sm:left-5" aria-live="polite" data-id="element-305" data-mp="jvjukgmnkwxz">
      <AnimatePresence data-id="element-306" data-mp="ex8j61gpmedn">
        {isVisible && !isDismissed && <motion.div key={index} initial={{
        opacity: 0,
        y: 12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 8,
        scale: 0.98
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-[calc(100vw-1.5rem)] max-w-xs items-center gap-3 rounded-xl border border-night-600 bg-night-800 p-3 pr-9 shadow-[0_12px_32px_rgba(0,0,0,0.45)]" data-id="element-307" data-mp="1ci4kdcnhd0zf">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-amber-deep" data-id="element-308" data-mp="3j9dprqyxsi6a">
              <ShoppingBagIcon className="h-5 w-5 text-amber" aria-hidden="true" data-id="element-309" data-mp="3kru7f2gehgeh" />
            </span>
            <div className="min-w-0" data-id="element-310" data-mp="3pokpfvbrmm2j">
              <p className="text-sm leading-snug text-cream" data-id="element-311" data-mp="3pnjdlomxdvjr">
                <span className="font-semibold" data-id="element-312" data-mp="3arto3gij70aa">{purchase.name}</span> z {purchase.city}
              </p>
              <p className="text-xs leading-snug text-cream-soft" data-id="element-313" data-mp="3fq4wdmt6h2qe">właśnie kupił(a) Arsenał Nauczyciela Jazzu</p>
              <p className="mt-1 flex items-center gap-1.5 text-[11px] text-cream-muted" data-id="element-314" data-mp="31z06hcfm3ot9">
                <BadgeCheckIcon className="h-3.5 w-3.5 text-amber" aria-hidden="true" data-id="element-315" data-mp="36skt68br8wd5" />
                Zweryfikowany zakup &middot; {timeLabel}
              </p>
            </div>
            <button type="button" onClick={() => setIsDismissed(true)} aria-label="Zamknij powiadomienie" className="absolute right-2 top-2 rounded p-1 text-cream-muted transition-colors duration-150 ease-out hover:text-cream" data-id="element-316" data-mp="2x29p8ls2mn69">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-317" data-mp="24frr82g1wphc" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}